export const criteriaKeys = {
    MinDepositValue: 'min_deposit_value',
    PackagesCount: 'packages_count',
    SingleProduct: 'single_product',
    ProductCategories: 'product_categories',
    AppScanned: 'app_scanned',
    TransactionTime: 'transaction_time',
};

export const criteriaConfig = {
    [criteriaKeys.MinDepositValue]: {
        label: 'campaign.criteria.minDepositValue',
        type: 'number',
        inputProps: { min: 0, step: 0.01 },
        adornment: 'PLN',
        initialValue: 0,
    },
    [criteriaKeys.PackagesCount]: {
        label: 'campaign.criteria.packagesCount',
        type: 'number',
        inputProps: { min: 1, step: 1 },
        initialValue: 1,
    },
    [criteriaKeys.SingleProduct]: {
        label: 'campaign.criteria.singleProduct',
        type: 'singleProduct',
        initialValue: null,
    },
    [criteriaKeys.ProductCategories]: {
        label: 'campaign.criteria.productCategories',
        type: 'categories',
        initialValue: [],
    },
    [criteriaKeys.AppScanned]: {
        label: 'campaign.criteria.appScanned',
        type: 'radio',
        options: [{ value: 'yes', label: 'campaign.criteria.appScannedLabel' }],
        initialValue: 'yes',
    },
    [criteriaKeys.TransactionTime]: {
        label: 'campaign.criteria.transactionTime',
        type: 'timeRange',
        placeholder: 'np. 9:00-17:00',
        initialValue: '',
    },
};

export const criteriaOptions = Object.keys(criteriaConfig);

export const resolveCriteriaKey = keyOrLabel => {
    if (!keyOrLabel) return undefined;
    if (criteriaConfig[keyOrLabel]) return keyOrLabel;
    const found = Object.entries(criteriaConfig).find(([, cfg]) => cfg.label === keyOrLabel);
    return found ? found[0] : undefined;
};

export const getInitialValueFor = key => criteriaConfig[key]?.initialValue;
